import { Button } from "@mui/material";
import styled from "@emotion/styled";

const GreyOutButton = styled(Button)({
  minWidth: "auto",
  backgroundColor: "#f5f5f5",
  border: "1px solid #ccc",
  color: "#000",
  "&:hover": {
    backgroundColor: "#e0e0e0",
    border: "1px solid #aaa",
  },
});

export default GreyOutButton;
